import { ZuschlagRabatt } from '@/types/service-response'

export class ProjectBookingBelegZuschlagRabatt {
  public constructor (
    readonly Rabatt: number | null, //double
    readonly RabbatKontoId: number | null,
    readonly Zuschlag: number | null, //double
    readonly ZuschlagKontoId: number | null,
    readonly Versandspesen: number | null //double
  ) {}

  static createFromResponse (responseData: ZuschlagRabatt): ProjectBookingBelegZuschlagRabatt {
      return new ProjectBookingBelegZuschlagRabatt(
        responseData.Rabatt !== null ? parseFloat(responseData.Rabatt.toFixed(2)) : null,
        responseData.RabbatKontoId,
        responseData.Zuschlag !== null ? parseFloat(responseData.Zuschlag.toFixed(2)) : null,
        responseData.ZuschlagKontoId,
        responseData.Versandspesen !== null ? parseFloat(responseData.Versandspesen.toFixed(2)) : null,
      )
  }
}
